import React from "react";
function AnimatedPage() {
  
  return (
    <>
      <div className="h-screen w-full bg-fill flex justify-center items-center flex-col fixed animate-Page duration-100 delay-500 transition-all overflow-hidden gap-5 z-50">
        <p className="-rotate-[15deg] font-fancy text-white text-xl before:absolute before:h-6 before:w-24 before:animate-EatReal before:bg-fill">
          Eat Real !
        </p>
        <h1 className="text-6xl animate-bal text-color-base font-simple font-black ">
          RFC
        </h1>
      </div>
    </>
  );
}

export default AnimatedPage;
